import { createFileRoute, notFound } from '@tanstack/react-router';

// eslint-disable-next-line no-restricted-imports -- S17: porta route leve, sem fixtures no JS inicial.
import { loadTenantPermissionResourceMessages } from '@/modules/tenant-permission-resource/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';

// /dev/permissoes-correspondente (só dev): as telas reais sobre o backend em memória.
export const Route = createFileRoute('/dev/permissoes-correspondente/')({
  beforeLoad: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- notFound é o contrato do Router.
    if (!import.meta.env.DEV) throw notFound();
  },
  loader: () => loadTenantPermissionResourceMessages(),
  component: import.meta.env.DEV
    ? lazyScreen(() => import('./-page'), 'TenantPermissionResourceDevPage')
    : () => null,
});
